import { render, staticRenderFns } from "./size-editor.vue?vue&type=template&id=56fc6c28&scoped=true"
import script from "./size-editor.vue?vue&type=script&lang=js"
export * from "./size-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc6c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fc6c28')) {
      api.createRecord('56fc6c28', component.options)
    } else {
      api.reload('56fc6c28', component.options)
    }
    module.hot.accept("./size-editor.vue?vue&type=template&id=56fc6c28&scoped=true", function () {
      api.rerender('56fc6c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/size-editor.vue"
export default component.exports